import { NextPage } from 'next'
import BibliographyLayout, {
  BibliographyLayoutTop,
} from '@chegg-wt/core/components/Layouts/Bibliography'
import { ApolloProviderWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import SEODeIndex from '@chegg-wt/core/components/Head/DeIndex'
import React from 'react'
import withApollo from '@chegg-wt/core/api/graphApi'
import { CM_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { useRouter } from 'next/router'
import { bibliographyB1, upsellCopy } from '../../copy/bibliography'
import { citationCopy } from '../../copy/citations'

const BibliographyPage: NextPage = () => {
  const router = useRouter()
  const { id: projectId } = router.query as { id: string }

  useOnUnloadTimeOnPage()
  return (
    <>
      <SEODeIndex />
      <BibliographyLayout
        copy={{ bibliographyB1, upsellCopy, citationCopy }}
        siteName={CM_PRODUCT_NAME}
        projectId={projectId}
      />
    </>
  )
}

const BibliographyPageWithApollo: ApolloProviderWithLayout = withApollo({
  ssr: false,
})(BibliographyPage)

BibliographyPageWithApollo.getPageLayout = (page) =>
  getLvpLayout(page, () => <BibliographyLayoutTop />, true)

export default BibliographyPageWithApollo
